import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

const footer = () => (
    <Footer style={{ textAlign: 'center' }}>Click Soluções WEB © 2008 / {new Date().getFullYear()}</Footer>
);

export default footer;